/**
***  placeholder  */
function setPlaceHolder(){
  const placeholderParent = document.querySelectorAll('.placeholder-parent');
  const focusClass = {
    in: 'focus-in',
    fixed: 'focus-fixed'
  }
  for ( let i = 0; i < placeholderParent.length; i++ ) {
    const child = placeholderParent[i].firstElementChild; //最初の子要素
    //const names = child.name;

    //console.log( form.names.value );

    child.addEventListener('focus', function(event) {
      placeholderParent[i].classList.add(focusClass.in);
    });
    child.addEventListener('blur', function(event) {
      placeholderParent[i].classList.remove(focusClass.in);
      placeholderParent[i].classList.remove(focusClass.fixed);
      if( child.value ){
        placeholderParent[i].classList.add(focusClass.fixed);
      }
    });
  }
}



/**
***  input change
***  @used jQuery
*/
function inputChange(el){
  const $el = el;

  $el.each(function(){
    $(this).on('keyup focus', changeEvt(this));
  });

  $el.each(function(){
    $(this).on('change', function(){
      const data = $(this).val();
      const hankaku = data.replace(/[０-９. ]/g,function(s){
        return String.fromCharCode(s.charCodeAt(0)- 65248);
      });
      $(this).val(hankaku);
    });
  });

  function changeEvt(e){
    let old = e.value;
    let v, str, othverVal, maxVal2;

    return function(){
      v = e.value;
      str = $(this).val();
      // 全角数字は半角数字へ変換, 数字以外の文字列は削除
      str = str.replace(/[^0-9 ０-９]+/, '');

      $(e).on('blur',function(){
        let str = $(this).val();
        str = str.replace(/[^0-9 ０-９]+/, '');
        $(this).val(str);
      });

      if (v !== str){
        $(e).val(str);
      }

      if ( old != v){
        old = v;
      }
    };
  }
};



// jQuery Validation Plugin
// submitHandler
// form の確認画面を表示する
// 引数（ Ajax送信ファイル, form のデータ, jQuery Validation Pluginのコールバックデータ
//
const confirmHandler = ( _file, _fd, _form ) => {
  $.post(
    _file, _fd
  ).done(function( data ) {
    $('body').addClass('overflow')
    $('#confirm-overlay').html( data )
    $('#closeBtn').on('click', function(){
      $('#confirm-overlay').empty()
      $('body').removeClass('overflow')
    });
    $('#submitBtn').on('click', function(){
      history.pushState( null, null, '/index.php' );
      _form.submit();
    });
  });
};
